<script>
import SessionManager, {SILKPLM_FREE} from "@/utils/SessionManager";
import {SCOPE_USER} from "@/utils/ConfigManager";
import {openMainMenu} from "@/components/dashboard/guides/guidNavigation";
import {
  addInspirationGuideSteps,
  createAddInspirationGuideSteps
} from "@/components/dashboard/guides/instructions/AddInspirationGuide";
import {
  createManageSubscriptionGuideSteps,
  manageSubscriptionGuideSteps
} from "@/components/dashboard/guides/instructions/ManageSubscriptionGuide";
import {isBelowBreakpoint} from "@/utils/Dom";
import {SUPPLIERS_PANEL} from "@/utils/Modules";
import ModulesConfiguration from "@/server/com/silkplm/model/users/ModulesConfiguration";
import {AIInpaintTutorialGuide} from "@/components/dashboard/guides/instructions/AIInpaintTutorialGuide";
import {
  AIInpaintTutorialGuideFromView
} from "@/components/dashboard/guides/instructions/AIInpaintTutorialGuideFromView";
import {inquiryGuideSteps} from "@/components/dashboard/guides/instructions/InquiryGuide";
import {brandingGuideSteps} from "@/components/dashboard/guides/instructions/BrandingGuide";
import DialogManager from "@/utils/DialogManager";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";

export default {
  name: "Guides",
  mounted() {
    window['Guides'] = this;
    // TODO - zakomentować, zeby dzialalo tylko raz przy autostarcie
    // let autostartDone = false;
    let autostartDone = SessionManager.configManager?.load("tour.autostart.done", null);
    if (!autostartDone) {
      this.$nextTick(() => {
        this.autostart();
      });
    }
  },

  methods: {
    autostart() {
      if(SessionManager.userSubscriptionType === SILKPLM_FREE){
        return;
      }
      // tu można zdecydować co puściś userowi w zależności skąd się tu wziął
      let autoconf = SessionManager.configManager?.load("tour.autostart.autoconf");
      if (autoconf === "supplier" || autoconf === "suppliers") {
        SessionManager.configManager?.save("tour.autostart.done.supplier", true, SCOPE_USER);
        SessionManager.configManager?.save("tour.autostart.done", true, SCOPE_USER).then(value => {
          let tmp = SessionManager.configManager?.load("tour.autostart.done", null);
        });
        return;
      }

      if (SessionManager.isOpen()) {
        let plan = SessionManager.configManager?.load("tour.autostart.preselectedPlan");
        // Jak bedzie wiecej tutoriali to tu mozna zroznicowac autostart zaleznie od wybranego planu
        if (SessionManager.hasFlag(FeatureFlag.AI_GENERATION_AND_VISUALIZATION)) {
          this.addInspiration();
        }
        SessionManager.configManager?.save("tour.autostart.done", true, SCOPE_USER);
      }

    },

    checkMenu() {
      let menu = "";
      if (isBelowBreakpoint('md')) {
        menu = "mobile-";
      }
      if (isBelowBreakpoint('md')) {
        menu = "mobile-";
      }
      return menu;
    },

    addInspiration() {
      this.beforeStart();
      let menu = this.checkMenu();
      this.activeSteps = createAddInspirationGuideSteps(menu);
      this.$tours['silkGuide'].start();
    },

    assignLabel() {
      this.beforeStart();
      let menu = this.checkMenu();
      this.activeSteps = brandingGuideSteps(menu);
      this.$tours['silkGuide'].start();
    },

    getInquiry() {
      this.beforeStart();
      let menu = this.checkMenu();
      this.activeSteps = inquiryGuideSteps(menu);
      this.$tours['silkGuide'].start();
    },

    manageSubscription() {
      if (SessionManager.userSubscriptionType !== SILKPLM_FREE) {
        this.beforeStart();
        let menu = "";
        if (isBelowBreakpoint('md')) {
          menu = "mobile-";
        }
        this.activeSteps = createManageSubscriptionGuideSteps(menu);
        this.$tours['silkGuide'].start();
      }
    },

    AIInpaintTutorial() {
      if (SessionManager.userSubscriptionType !== SILKPLM_FREE) {
        this.beforeStart();
        let menu = "";
        if (isBelowBreakpoint('md')) {
          menu = "mobile-";
        }
        this.activeSteps = AIInpaintTutorialGuide(menu);
        this.$tours['silkGuide'].start();
      }
    },

    AIInpaintTutorialFromView() {
      if (SessionManager.userSubscriptionType !== SILKPLM_FREE) {
        let menu = "";
        if (isBelowBreakpoint('md')) {
          menu = "mobile-";
        }
        let plan = SessionManager.configManager?.load("tour.Inpaint.done");
        //jeśli open to znaczy że nowa
        // console.log(SessionManager.organizationSubscriptionType);

        if (!plan) {
          SessionManager.configManager?.save("tour.Inpaint.done", true, SCOPE_USER);
          this.guideActive = true;
          this.activeSteps = AIInpaintTutorialGuideFromView(menu);
          this.$tours['silkGuide'].start();
        } else {
          this.guideActive = false;
        }
      }
    },

    async beforeStart() {
      this.guideActive = true;
      await ActivityManager.closeAll(false);
      await openMainMenu();
    },

    cleanup() {
      this.guideActive = false;
    },

    stopTour() {
      this.$refs.tour.stop();
    }
  },
  data: function () {
    return {
      guideActive: false,
      activeSteps: []
    }
  }
}
</script>

<template>
  <div>
    <div ref="glass" id="#guidesGlass" v-if="guideActive" tabindex="-1"
         style="position: absolute; top:0;
         pointer-events: auto;
         z-index: 3000000;
         bottom: 0; left: 0; right: 0; background-color: rgba(1,1,1,3%)"
    >
    </div>
    <v-tour ref="tour" name="silkGuide" :steps="activeSteps" @stopped="cleanup"></v-tour>
  </div>
</template>

<style scoped>

</style>